function checkIsRemovalProposal(data) {
  return data.kind === "delete_criterion" || data.kind === "delete_section";
}
function isUnmeasuredProposalDetail(payload) {
  return "kind" in payload;
}
export {
  checkIsRemovalProposal,
  isUnmeasuredProposalDetail
};
//# sourceMappingURL=playbookProposalDetail.js.map
